__turbopack_context__.v({
  "animate-promo-dot-fill": "animations-module__VlmtRq__animate-promo-dot-fill",
  "animate-promo-fade-in": "animations-module__VlmtRq__animate-promo-fade-in",
  "promo-dot-fill": "animations-module__VlmtRq__promo-dot-fill",
  "promo-fade-in": "animations-module__VlmtRq__promo-fade-in",
});
